import { ParsedItem } from 'store/declaration-form-errors/ParsedForm';

/**
 * How many errors the form validation found in an item: one per invalid field, as the validation
 * sidebar lists them. A card that names no field still counts as one error.
 */
const countParsedItemErrors = (item: ParsedItem): number =>
    (item.errors ?? []).reduce((total, card) => total + Math.max(card.fields?.length ?? 0, 1), 0);

export default countParsedItemErrors;
